<template>
	<nut-swipe ref="swipeRef" touch-move-stop-propagation @open="handleOpen">
		<div
			class="item"
			:style="{
				backgroundColor: selfData.on_show == 0 ? 'rgba(0,0,0,.25)' : '',
			}"
		>
			<div class="item-left" @click.stop.prevent="handleLeftClick">
				<template v-if="type !== 'subtitle'">
					<img
						class="img"
						:src="
							type === 'view'
								? selfData.icon ||
								  (selfData.type === 'picture'
										? 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/inn1.png'
										: 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/nw_5.png')
								: type === 'audio'
								? 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/nw_1.png'
								: 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/nw_4.png'
						"
						alt=""
					/>
					<span class="name">{{ selfData.title }}</span>
				</template>
				<template v-else-if="type === 'subtitle'">
					<span class="name">{{ selfData.subtitle }}</span>
				</template>
			</div>
			<nut-button
				v-if="type === 'view' || type === 'subtitle'"
				type="primary"
				size="mini"
				@click="
					handlePlay(
						type === 'view' ? selfData.media_id : selfData.id
					)
				"
			>
				点播
			</nut-button>
			<template v-if="type === 'audio' || type === 'html'">
				<div class="play-container">
					<span class="duration">{{
						formatDuration(selfData.duration)
					}}</span>
					<div>
						<nut-button
							v-if="
								(type === 'html' &&
									parseInt(selfData.game_config_id) > 1) ||
								parseInt(selfData.editable)
							"
							style="margin-right: 8px"
							type="primary"
							plain
							size="mini"
							@click="
								$router.push(
									`/raffle?mediaId=${selfData.media_id}`
								)
							"
						>
							编辑
						</nut-button>
						<nut-button
							type="primary"
							size="mini"
							@click="handlePlay(selfData.media_id)"
						>
							点播
						</nut-button>
					</div>
				</div>
			</template>
		</div>
		<template #right>
			<!-- html 无撤下展播操作 -->
			<nut-button
				v-if="type !== 'html'"
				@click="handleToggleStatus(selfData.id, selfData.on_show)"
				shape="square"
				style="height: 100%"
				type="primary"
			>
				{{ selfData.on_show == 1 ? '撤下' : '展播' }}
			</nut-button>
			<nut-button
				@click="handleRemove(selfData.id)"
				shape="square"
				style="height: 100%"
				type="danger"
			>
				移除
			</nut-button>
		</template>
	</nut-swipe>
</template>

<script>
import { ref } from 'vue';
import { Dialog, Toast } from '@nutui/nutui';
import { playlistApi } from '@/apis';
import { PLAYLIST_TYPE } from '@/constants';
import { formatDuration } from '@/utils/util.time';

export default {
	name: 'SwipeItem',
	props: {
		type: {
			type: String,
			default: 'view',
		},
		itemData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	emits: ['leftClick', 'deleteSuccess', 'open'],
	setup(props, { emit }) {
		const swipeRef = ref(null);
		const selfData = ref(props.itemData);

		// 点播
		const handlePlay = async (id) => {
			const { type } = props;
			const api =
				type !== 'subtitle'
					? playlistApi.play_item
					: playlistApi.play_subtitle;
			await api({
				media_id: id,
				type: PLAYLIST_TYPE[type],
			});
			Toast.success('命令已发送');
		};
		const handleRemove = async (id) => {
			const { type } = props;
			// nut3.1.18 不支持异步关闭
			Dialog({
				title: '提示',
				content: '您确定要移除吗？',
				async onOk() {
					await playlistApi.playlist_remove_one({
						id,
						type,
					});
					Toast.success('删除成功');
					emit('deleteSuccess', id);
				},
			});
		};
		const handleToggleStatus = async (id, onshow) => {
			const { type } = props;
			const onoff = onshow == 1 ? 0 : 1;
			await playlistApi.playlist_hide_show({
				id,
				type,
				on_show: onoff,
			});
			selfData.value.on_show = onoff;
			Toast.success('成功');
			swipeRef.value.close();
		};

		const handleLeftClick = () => {
			emit('leftClick');
		};

		const handleOpen = () => {
			// 监听打开 然后关闭其他的
			emit('open', swipeRef.value);
		};

		return {
			swipeRef,
			selfData,

			handlePlay,
			handleRemove,
			handleToggleStatus,
			handleLeftClick,
			handleOpen,
			formatDuration,
		};
	},
};
</script>

<style lang="scss" scoped>
.item {
	@include flex-center;
	padding: 8px 15px;
	border-bottom: 1px solid #dedede;
	border-right: 1px solid #0096ff;
	font-size: 12px;
	&-left {
		min-width: 0;
		flex: 1;
		@include flex-center;
		justify-content: flex-start;

		.img {
			width: 30px;
			height: 30px;
			margin-right: 8px;
		}

		.name {
			height: 30px;
			line-height: 30px;
			flex: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
	.play-container {
		@include flex-center;
		flex-direction: column;

		.duration {
			margin-bottom: 4px;
		}
	}
}
</style>
